module.exports = function only(obj, ...props) {
  var child = {}

  for (let key of props) {
    child[key] = obj[key]
  }

  return child
}



/** WEBPACK FOOTER **
 ** ./lib/only.js
 **/